<template>
  <div>
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel height="550px">
        <!-- <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item> -->
        <el-carousel-item v-for="item in image" :key="item.id">
          <img :src="item.image" alt="" />
          <div class="tiyan" @click="goBto">立即体验</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 end------------------->

    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">财务管理</div>
        <br />
        <div class="t2">专业高效</div>
      </div>

      <!-- 内容 -->

      <img class="img1" src="@/image/home/TU1@2x.png" alt="" />

      <img class="img2" src="@/image/home/TU2@2x.png" alt="" />

      <div class="r1-textbox">
        <div class="title">个人/企业财务</div>
        <div class="lineb"></div>
        <div class="text">
          <div class="t1">财务问题 税务清缴 报账服务</div>
          <div class="t1">公司财务 精准税务 财资服务</div>
        </div>
      </div>

      <div class="r1-textbox2">
        <div class="title">个人/企业财务</div>
        <div class="lineb"></div>
        <div class="text">
          <div class="t1">个人债务解决方案规划</div>
          <div class="t2">全方位服务合理筹划解决债务</div>
        </div>
      </div>
    </div>

    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">品质保障 安全无忧</div>
        <br />
        <div class="t2">专业高效</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">2000+</div>
          <div class="t2">超2000+企业/个人共同选择 拷贝</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">99%</div>
          <div class="t2">客户好评率达99% 拷贝</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">3w</div>
          <div class="t2">服务咨询人数达3W+ 拷贝</div>
        </div>
      </div>
      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">信息技术服务</div>
        <br />
        <div class="t2">用技术创造商业价值</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/APP@2x.png" alt="" />
          </div>
          <div class="text1">移动APP开发</div>

          <div class="text2">基于安卓系统和ios系统</div>
          <div class="text3">APP软件定制开发</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/XIAOCHENGXU@2x.png" alt="" />
          </div>
          <div class="text1">小程序开发</div>

          <div class="text2">微信小程序</div>
          <div class="text3">及内部系统的微信对接</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/WANGZHAN@2x.png" alt="" />
          </div>
          <div class="text1">网站制作</div>

          <div class="text2">电脑PC站+手机网站</div>
          <div class="text3">适应各类尺寸的终端屏幕</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/CUNCHU@2x.png" alt="" />
          </div>
          <div class="text1">分布式存储</div>

          <div class="text2">系统稳定可靠</div>
          <div class="text3">加密碎片数据 安全无忧</div>
        </div>
      </div>
    </div>

    <div class="row4">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的优势</div>
        <br />
        <div class="t2">致力于优质的服务完美的解决方案</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/dingzhi@2x.png" alt="" />
          </div>
          <div class="text1">按客户需求定制</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/ruanzhu@2x.png" alt="" />
          </div>
          <div class="text1">可申请软著</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/shangjia@2x.png" alt="" />
          </div>
          <div class="text1">免费备案及上架</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/jiage@2x.png" alt="" />
          </div>
          <div class="text1">价格低 更优惠</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/yuanma@2x.png" alt="" />
          </div>
          <div class="text1">交付源码</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/guifan@2x.png" alt="" />
          </div>
          <div class="text1">规范的开发流程</div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row5">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu3@2x.png" alt="" />
          </div>

          <div class="text1">企业</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu4@2x.png" alt="" />
          </div>

          <div class="text1">零售</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu5@2x.png" alt="" />
          </div>

          <div class="text1">母婴</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu6@2x.png" alt="" />
          </div>

          <div class="text1">超市</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu7@2x.png" alt="" />
          </div>

          <div class="text1">餐饮</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu8@2x.png" alt="" />
          </div>

          <div class="text1">酒店</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu9@2x.png" alt="" />
          </div>

          <div class="text1">景区</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu10@2x.png" alt="" />
          </div>

          <div class="text1">教育</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu11@2x.png" alt="" />
          </div>

          <div class="text1">医疗</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu12@2x.png" alt="" />
          </div>

          <div class="text1">政务</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu13@2x.png" alt="" />
          </div>

          <div class="text1">金融</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu14@2x.png" alt="" />
          </div>

          <div class="text1">娱乐</div>

          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="row6">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="b1">
          <div class="t1">“</div>
          <div class="t2">
            这是一个最好的时代；<br />
            也是一个最坏的时代。<br />
            在无奈的新常态下，<br />
            我们的生活还要继续，<br />
            但是我们的债务从来不会停止，<br />
            如何在特殊时期处理债务我们最专业。
          </div>
          <div class="t3">欢迎加入我们</div>
        </div>

        <div class="b2">
          <img src="@/image/home/tu15@2x.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxxIndex',

  data() {
    return {
      image: [],
    }
  },

  mounted() {
    this.getbanner()
  },

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
    getbanner() {
      this.$axios
        .get('/index/Dt/banner', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.image = res.data.data.list
          for (const i of this.image) {
            i.image = this.$axios.defaults.baseURL + i.image
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
//轮播图
.block {
  width: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .tiyan {
    margin-left: 2px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #4581fb;
    border-radius: 4px;
    position: absolute;
    left: 21%;
    bottom: 28%;
  }

  /deep/ .el-carousel__button {
    // 默认按钮的颜色大小等
    width: 36px;
    height: 4px;
    border: none;
    border-radius: 20px;
    background: #ffffff;
    opacity: 1;
  }

  /deep/ .is-active .el-carousel__button {
    // 选中图片的颜色
    background: #14a5fe;
    opacity: 1;
  }
}

.row1 {
  height: 950px;
  position: relative;

  .img1 {
    position: absolute;
    top: 90px;
    left: 20%;
    width: 600px;
    height: 400px;
  }
  .img2 {
    position: absolute;
    left: 50%;
    bottom: 150px;
    width: 600px;
    height: 400px;
  }

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .r1-textbox {
    position: absolute;
    top: 100px;
    width: 300px;
    height: 180px;
    right: 28%;

    .lineb {
      position: absolute;
      top: 90px;
      height: 2px;
      width: 30px;
      background-color: #14a5fe;
    }
    .title {
      letter-spacing: 1px;
      position: absolute;
      top: 10px;
      font-size: 25px;
    }
    .text {
      position: absolute;
      font-size: 20px;
      bottom: 0;
      letter-spacing: 1px;
      color: #999999;
    }
  }

  .r1-textbox2 {
    position: absolute;
    bottom: 200px;
    width: 300px;
    height: 180px;
    left: 30%;

    .lineb {
      position: absolute;
      top: 90px;
      right: 30px;
      height: 2px;
      width: 30px;
      background-color: #14a5fe;
    }
    .title {
      right: 30px;
      letter-spacing: 1px;
      position: absolute;
      top: 10px;
      font-size: 25px;
    }
    .text {
      position: absolute;
      font-size: 20px;
      bottom: 0;
      letter-spacing: 1px;
      color: #999999;
      width: 100%;
      .t1 {
        position: absolute;
        right: 30px;
        bottom: 30px;
      }
    }
  }
}

.row2 {
  height: 690px;
  overflow: hidden;

  background-color: #f7f8fb;
  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 90px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 150px auto;
    justify-content: space-around;

    .r2-tiem {
      background-color: #ffffff;
      height: 160px;
      width: 260px;
      position: relative;
      border-radius: 6px;

      img {
        margin-top: 15px;
        height: 24px;
        width: 120px;
      }
      .t1 {
        overflow: hidden;
        width: 45%;
        font-size: 38px;
        font-weight: 600;
        margin: 20px auto;
        text-align: center;
      }
      .t2 {
        margin: 100px auto 0 auto;
        text-align: center;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 180px auto;
  }
}

.row3 {
  height: 650px;

  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 120px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 280px;
      height: 320px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 45px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }

      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      color: #4581fb;
      transition-timing-function: linear;
    }
  }
}

.row4 {
  height: 800px;
  background-color: #313131;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #ffffff;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 95px;
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 380px;

    margin: 150px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 380px;
      height: 120px;
      background-color: #404040;
      // border: 1px solid;
      display: flex;
      // justify-content: center;

      align-items: center;
      margin-right: 60px;
      // box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 64px;
        height: 64px;
        margin-left: 35px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 200px;
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        letter-spacing: 2px;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 170px;
    left: 850px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 2px;
  }
}

.row5 {
  height: 870px;
  overflow: hidden;
  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1700px;
    height: 650px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 200px;
      height: 210px;
      position: relative;
      // border: 1px solid;
      margin-right: 30px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        position: absolute;
        top: 0;
        width: 200px;
        height: 210px;
        z-index: -100;

        img {
          background-color: #000;
          opacity: 2;
          width: 100%;
          height: 100%;
        }
      }
      .img::after {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.3;
      }

      .text1 {
        width: 200px;
        text-align: center;
        margin: 140px auto 16px auto;
        color: #ffffff;
        font-size: 22px;
        text-align: center;
        letter-spacing: 2px;
      }
      .line {
        background-color: #ffffff;

        height: 2px;
        width: 40px;
        margin: 10px auto;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }
}

.row6 {
  height: 860px;
  overflow: hidden;
  position: relative;
  background-color: #f7f8fb;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1400px;
    height: 500px;
    margin: 100px auto 0 auto;
    box-sizing: border-box;

    .b1 {
      width: 50%;
      background-color: #ffffff;

      position: relative;

      .t1 {
        font-size: 120px;
        position: absolute;
        top: 60px;

        color: #4581fb;
      }

      .t2 {
        position: absolute;
        letter-spacing: 1px;
        line-height: 30px;
        font-size: 18px;
        left: 180px;
        top: 120px;
        color: #333333;
      }

      .t3 {
        color: #4581fb;
        position: absolute;
        bottom: 90px;
        font-size: 33px;
        left: 220px;
      }
    }

    .b2 {
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
